(() => {
  const EASIFY_CHECKOUT_SELECTOR =
    '.BOX_REVIEW_PAGE_CHECKOUT_BUTTON_TS, [class*="orderDetail-module__summary_btn_checkout"]';
  const NATIVE_CHECKOUT_SELECTORS = [
    '#CartDrawer-Checkout',
    '#checkout',
    '#cart-notification-form button[name="checkout"]',
    'form[action*="/cart"] button[name="checkout"]',
    'magic-checkout-btn:not([page-type="product"])',
  ];
  const pendingTimeout = 30000;
  const completionTimeout = 10000;
  let pendingCheckout = null;

  function preserveCheckoutLabel(root = document) {
    if (!document.documentElement?.lang?.toLowerCase().startsWith('en')) return;

    const buttons = [];
    if (root.nodeType === Node.ELEMENT_NODE && root.matches(EASIFY_CHECKOUT_SELECTOR)) {
      buttons.push(root);
    }
    if (root.querySelectorAll) {
      buttons.push(...root.querySelectorAll(EASIFY_CHECKOUT_SELECTOR));
    }

    buttons.forEach((button) => {
      const textNodes = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
      let textNode = textNodes.nextNode();

      while (textNode) {
        if (textNode.nodeValue.trim().toLowerCase() === 'add to cart') {
          textNode.nodeValue = textNode.nodeValue.replace(/add to cart/i, 'Check out');
        }

        textNode = textNodes.nextNode();
      }

      if (button.getAttribute('aria-label')?.trim().toLowerCase() === 'add to cart') {
        button.setAttribute('aria-label', 'Check out');
      }
    });
  }

  function watchCheckoutLabel() {
    if (!window.MutationObserver || !document.body) return;

    preserveCheckoutLabel();
    const labelObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          const button = mutation.target.parentElement?.closest(EASIFY_CHECKOUT_SELECTOR);
          if (button) preserveCheckoutLabel(button);
          return;
        }

        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) preserveCheckoutLabel(node);
        });
      });
    });
    labelObserver.observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  function getBoxReviewSettings() {
    return window.subscription_box_builder?.box_set?.additional_data?.theme_settings?.box_review_page;
  }

  function routeEasifyThroughCartDrawer() {
    const settings = getBoxReviewSettings();
    if (!settings || typeof settings.redirect !== 'string') return false;

    if (settings.redirect.includes('checkout')) {
      settings.redirect = '/cart_drawer';
    }

    return true;
  }

  function requestUrl(resource) {
    if (typeof resource === 'string') return resource;
    if (resource instanceof URL) return resource.href;
    return resource?.url || '';
  }

  function isCartAddRequest(resource) {
    try {
      const url = new URL(requestUrl(resource), window.location.origin);
      return /\/cart\/add(?:\.js)?$/.test(url.pathname);
    } catch (_error) {
      return false;
    }
  }

  function isPendingCheckoutCurrent() {
    return pendingCheckout && Date.now() - pendingCheckout.startedAt < pendingTimeout;
  }

  function getEnabledCheckoutControl() {
    for (const selector of NATIVE_CHECKOUT_SELECTORS) {
      const controls = document.querySelectorAll(selector);
      const control = Array.from(controls).find(
        (candidate) =>
          !candidate.disabled &&
          candidate.getAttribute('aria-disabled') !== 'true' &&
          candidate.getClientRects().length > 0
      );

      if (control) return control;
    }

    return null;
  }

  function easifyIsStillWorking(originalButton) {
    const button = originalButton?.isConnected
      ? originalButton
      : document.querySelector(EASIFY_CHECKOUT_SELECTOR);

    if (!button) return false;

    return (
      button.disabled ||
      button.getAttribute('aria-busy') === 'true' ||
      button.classList.contains('loading') ||
      Boolean(button.querySelector('.loading, [class*="loading"], [class*="spinner"]'))
    );
  }

  function launchMagicCheckout(originalButton) {
    const startedAt = Date.now();

    const waitForEasify = window.setInterval(() => {
      const timedOut = Date.now() - startedAt >= completionTimeout;
      if (!timedOut && easifyIsStillWorking(originalButton)) return;

      const checkoutControl = getEnabledCheckoutControl();
      if (!checkoutControl && !timedOut) return;

      window.clearInterval(waitForEasify);
      pendingCheckout = null;

      if (checkoutControl) {
        checkoutControl.click();
        return;
      }

      window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
    }, 100);
  }

  function handleSuccessfulCartAdd(response, currentCheckout) {
    if (
      !isPendingCheckoutCurrent() ||
      pendingCheckout !== currentCheckout ||
      currentCheckout.cartAddCompleted ||
      !response.ok
    ) {
      return;
    }

    currentCheckout.cartAddCompleted = true;
    window.setTimeout(() => launchMagicCheckout(currentCheckout.button), 200);
  }

  const nativeFetch = window.fetch;
  window.fetch = function (...args) {
    const cartAddForEasify = isPendingCheckoutCurrent() && isCartAddRequest(args[0]);
    const currentCheckout = pendingCheckout;
    const request = nativeFetch.apply(this, args);

    if (cartAddForEasify) {
      request.then((response) => handleSuccessfulCartAdd(response, currentCheckout)).catch(() => {
        if (pendingCheckout === currentCheckout) pendingCheckout = null;
      });
    }

    return request;
  };

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest?.(EASIFY_CHECKOUT_SELECTOR);
      if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

      routeEasifyThroughCartDrawer();
      pendingCheckout = {
        button,
        startedAt: Date.now(),
        cartAddCompleted: false,
      };
    },
    true
  );

  routeEasifyThroughCartDrawer();
  watchCheckoutLabel();

  const settingsTimer = window.setInterval(() => {
    if (routeEasifyThroughCartDrawer()) window.clearInterval(settingsTimer);
  }, 250);

  window.setTimeout(() => window.clearInterval(settingsTimer), 5000);
})();
